const ACCITEM = [
  {
    id:'1',
    name:'까르띠에 러브 팔찌1',
    price:1200000,
    img: require('../assets/images/home/section2/1.jpg'),
    sellCount:10,
    delivery:0
  },
  {
    id:'2',
    name:'까르띠에 러브 팔찌2',
    price:1200000,
    img: require('../assets/images/home/section2/1.jpg'),
    sellCount:20,
    delivery:0
  },
  {
    id:'3',
    name:'까르띠에 러브 팔찌3',
    price:1200000,
    img: require('../assets/images/home/section2/1.jpg'),
    sellCount:30,
    delivery:0
  },{
    id:'4',
    name:'까르띠에 러브 팔찌4',
    price:1200000,
    img: require('../assets/images/home/section2/1.jpg'),
    sellCount:40,
    delivery:0
  },
  {
    id:'5',
    name:'까르띠에 러브 팔찌5',
    price:1200000,
    img: require('../assets/images/home/section2/1.jpg'),
    sellCount:50
  },
  {
    id:'6',
    name:'까르띠에 러브 팔찌6',
    price:1200000,
    img: require('../assets/images/home/section2/1.jpg'),
    sellCount:60,
    delivery:0
  }
]

export default ACCITEM;